import React from 'react';

import Select from 'components/Select';

import './styles.css';

const NOTES_OPTIONS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived'
};

const FILTER_NOTES_OPTIONS = [
  {label: 'Active notes', value: NOTES_OPTIONS.ACTIVE},
  {label: 'Archived', value: NOTES_OPTIONS.ARCHIVED}
];

class NotesFilters extends React.Component<any> {
  state = {
    selectedOption: FILTER_NOTES_OPTIONS[0]
  };

  onActiveSelect = () => {
    this.props.filterActiveNotes();
  };

  onArchivedSelect = () => {
    this.props.filterArchivedNotes();
  };

  filterNotes = option => {
    if (option.value === NOTES_OPTIONS.ACTIVE) {
      this.setState(
        {
          selectedOption: option
        },
        this.onActiveSelect
      );
    }

    if (option.value === NOTES_OPTIONS.ARCHIVED) {
      this.setState(
        {
          selectedOption: option
        },
        this.onArchivedSelect
      );
    }
  };

  render() {
    const {selectedOption} = this.state;

    return (
      <div className="NotesFilters">
        <Select
          onChange={this.filterNotes}
          value={selectedOption}
          options={FILTER_NOTES_OPTIONS}
          clearable={false}
        />
      </div>
    );
  }
}

export default NotesFilters;
